// extracted by mini-css-extract-plugin
export default {"tabContainer":"tab-container__tab-container__zjt06"};